import React from 'react'
import { useSelector } from 'react-redux'
import { ConfigProvider } from 'components/ui'
import useDarkMode from 'utils/hooks/useDarkMode'
import useDensity from 'views/v2/hooks/useDensity'
import { themeConfig } from 'configs/theme.config'

const Theme = props => {

	const theme = useSelector(state => state.theme)
	const [ isDark ] = useDarkMode()

	// Apply the saved/default density even when the density selector is hidden.
	// this uses the mode that is present in the localstorage in admin key, which is stored by redux-persist library
	useDensity()

	const currentTheme = {
		mode: isDark ? 'dark' : 'light',
		...themeConfig,
		...theme
	}

	return (
		<>
			<ConfigProvider value={currentTheme}>
				{props.children}
			</ConfigProvider>
		</>
	)
}

export default Theme
